import { Component } from '@angular/core';
import { ApiService } from '../_services/api.service';
import { Router } from '@angular/router';
import { ConfigService } from '../_services/config.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'true-node-selector',
  templateUrl: './node-selector.component.html',
  styleUrl: './node-selector.component.scss',
  standalone: false
})
export class NodeSelectorComponent {
  public nodesEnabled: any[] = null;
  private assessment: any = null;
  public error:boolean = false;
  public errorMessage:string = "";
  assessmentName: string = "/";
  assessmentObject: string = "";

  private nodes = [
    {"icon": "production.svg", "key": "RadiantProduction", "name": "PRODUCTION", "enabled": true},
    {"icon": "processing.svg", "key": "RadiantProcessing", "name": "PROCESSING", "enabled": true},
    {"icon": "transport.svg", "key": "RadiantTransportAndDistribution", "name": "TRANSPORT & DISTRIBUTION", "enabled": true},
    {"icon": "markets.svg", "key": "RadiantMarketAndRetailers", "name": "MARKETS & RETAILERS", "enabled": true}
  ];

  constructor(private api: ApiService, private router: Router, public readonly config: ConfigService) {}

  ngOnInit() {
    this.api.getAssessment().subscribe((assessment) => {
      this.assessment = assessment;
      this.assessmentName = assessment.name;
      this.assessmentObject = assessment.object;
      let nodesEnabled = JSON.parse(JSON.stringify(this.nodes));
      console.log(assessment.nodes);
      if (assessment && assessment.nodes) {
        nodesEnabled.forEach((node) => {
          const matchingNode = assessment.nodes.find((aNode) => aNode.key === node.key);
          if (matchingNode) {
            node.enabled = matchingNode.enabled;
          }
        });
        console.log(nodesEnabled);
      }
      this.nodesEnabled = nodesEnabled;
    });
  }  

  next() {
    if (this.nodesEnabled.filter(node => node.enabled).length === 0) {
      this.error = true;
      this.errorMessage = "Please enable at least one node";
      return;
    }
  
    this.setNodeSelection().subscribe(() => {
      this.router.navigate(['/input']);
    });
  }

  setNodeSelection(): Observable<any> {
    const payload = this.nodesEnabled.map(node => ({
      key: node.key,
      enabled: node.enabled
    }));
  
    return this.api.updateAssessment(this.assessment.id, null, payload);
  }

}
